




import { computed, defineComponent } from '@vue/composition-api'
import type { OrderableItemData } from '@futureecom/futureecom-js/dist/services/cart-service'
import type { PropType } from '@vue/composition-api'

export default defineComponent({
  name: 'OrderableAddProductSectionNote',

  props: {
    value: {
      type: Object as PropType<OrderableItemData>,
      default: undefined
    }
  },

  setup(props, { emit }) {
    const notes = computed({
      get: () => (Array.isArray(props.value?.notes) ? props.value?.notes[0] : ''),
      set: (notes: string) => emit('input', { ...props.value, notes: notes ? [notes] : null })
    })

    return {
      notes
    }
  }
})
